function handleScroll() {
    var e = document.getElementsByClassName("support-floating")[0],
        t = document.getElementsByClassName("botaoflutuante")[0], n = document.getElementById("evolutionpro-price-list"),
        o = null;
    t && (o = window.getComputedStyle(t)), e && n && (e.style.bottom = null != o && "block" === o.display ? "65px" : "15px")
}

function increaseValue() {
    var e = parseInt(document.getElementById("number").value, 10);
    e = isNaN(e) ? 0 : e, e++, document.getElementById("number").value = e
}

function decreaseValue() {
    var e = parseInt(document.getElementById("number").value, 10);
    1 !== (e = isNaN(e) ? 0 : e) && e--, document.getElementById("number").value = e
}

function serialize(e) {
    function t(e, n) {
        var o = e.lastIndexOf("[");
        if (-1 === o) {
            var a = {};
            return a[e] = n, a
        }
        var i = e.substr(0, o), r = {};
        return r[e.substring(o + 1, e.length - 1)] = n, t(i, r)
    }

    for (var n = {}, o = 0, a = e.elements.length; o < a; o++) {
        var i = e.elements[o];
        if ("" !== i.name && !i.disabled) if (i.name && !i.disabled && (i.checked || /select|textarea/i.test(i.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(i.type))) n = extend(n, t(i.name, i.value))
    }
    return n
}

function extend() {
    for (var e = {}, t = 0, n = function (t) {
        for (var n in t) t.hasOwnProperty(n) && ("[object Object]" === Object.prototype.toString.call(t[n]) ? e[n] = Form.extend(e[n], t[n]) : e[n] = t[n])
    }; t < arguments.length; t++) n(arguments[t]);
    return e
}

window.onload = function () {
    if (window.matchMedia("(max-width: 768px)").matches) {
        handleScroll(), window.onscroll = handleScroll;
        var e = document.getElementsByClassName("support-floating")[0],
            t = document.getElementsByClassName("botaoflutuante")[0], n = null;
        t && (n = window.getComputedStyle(t)), e && null != n && "block" === n.display && (e.style.bottom = "65px")
    }
}, $(".block-swatch__radio, .variant-swatch__radio, .product-form__single-selector").change((function () {
    setTimeout((function () {
        parcelamento()
    }), 150)
})), $(".options:first-child").addClass("active"), $(".options").each((function () {
    $(this).on("click", (function () {
        $(".options").removeClass("active"), $(this).addClass("active"), $("#evolutionpro-price-list .price-promotional-wrap strong").html($(this).find(".valortot").text()), $("#evolutionpro-price-list .price-promotional-wrap span").html($(this).find(".valorcomp").text()), $("#evolutionpro-price-list .price-promotional-wrap .selector-desconto").remove(), $("#evolutionpro-price-list .price-promotional-wrap").append('<p class="selector-desconto">CUPOM ' + $(this).find(".saving").text() + " APLICADO</p>"), parcelamento()
    }))
})), $(".product-form").each((function () {
    $(this).on("click", ".botaocmprar, .botaoaddcarrinho-qtd", (function (e) {
        e.stopImmediatePropagation();
        const t = "botaoaddcarrinho" === $(this).attr("id") || !window.theme.botaoaddcarrinho, n = [],
            o = parseInt($(".options.active .iddavariante").attr("val")),
            a = parseInt($(".options.active .iddavariante").attr("qtd"));
        n.push({id: o, quantity: a}), $(".buy-together-list input").each((function () {
            !0 === $(this).prop("checked") && n.push({id: $(this).attr("data-id"), quantity: 1})
        }));
        let i = {items: n};
        fetch("".concat(window.routes.cartAddUrl, ".js"), {
            body: JSON.stringify(i),
            credentials: "same-origin",
            method: "POST",
            headers: {"Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest"}
        }).then((function (e) {
            if (e.ok) if ("drawer" === window.theme.cartType && t) {
                document.dispatchEvent(new CustomEvent("theme:loading:end"));
                const e = document.querySelector('[data-section-id="product-template"]');
                e && e.dispatchEvent(new CustomEvent("product:added", {
                    bubbles: !0,
                    detail: {variant: n[1], quantity: 1}
                }))
            } else setTimeout((function () {
                window.location.href = "/cart"
            }), 500)
        }))
    }))
}));
const youtubeVideos = [...document.querySelectorAll("[data-youtube]")];
youtubeVideos.forEach((function (e) {
    e.querySelector("[data-youtube-button]").addEventListener("click", (function () {
        const e = event.target.dataset.youtubeButton, t = event.target.parentNode,
            n = '<iframe width="100%" src="' + e + '?autoplay=1&showinfo=0&controls=1&rel=0&modestbranding=1" allow="autoplay;" frameborder="0" allowfullscreen></iframe>';
        t.style.display = "none", t.insertAdjacentHTML("beforebegin", n), t.parentNode.removeChild(t)
    }))
})), $(document).ready((function () {
    (function (e, t) {
        t || (t = window.location.href), e = e.replace(/[\[\]]/g, "\\$&");
        var n = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(t);
        return n ? n[2] ? decodeURIComponent(n[2].replace(/\+/g, " ")) : "" : null
    })("customer_posted") && $(".modal--newsletter").attr("aria-hidden", "false");
    const e = document.getElementById("copiar-cupom");
    e && e.addEventListener("click", (function () {
        var e = document.getElementById("texto-cupom");
        navigator.clipboard && navigator.clipboard.writeText(e.innerText).then((function () {
        })).catch((function (e) {
        }))
    }))
}));
const miniCart = document.querySelector(".mini-cart");
let observer = null;

function handleMutation(e, t) {
    for (const t of e) if ("aria-hidden" === t.attributeName) {
        const e = "true" === t.target.getAttribute("aria-hidden");
        document.documentElement.style.overflow = e ? "auto" : "hidden"
    }
}

function startObserver() {
    (observer = new MutationObserver(handleMutation), observer.observe(miniCart, {
        attributes: !0,
        attributeFilter: ["aria-hidden"]
    }))
}

function stopObserver() {
    observer && (observer.disconnect(), observer = null)
}

window.addEventListener("load", startObserver), window.addEventListener("resize", (function () {
    startObserver()
}));



/* Popup fallback v12 */
document.addEventListener('DOMContentLoaded', function() {
  var modal = document.querySelector('.modal--newsletter[data-popup-type="newsletter"]');
  if (!modal || modal.dataset.skinPopupReady === 'true') return;
  modal.dataset.skinPopupReady = 'true';
  var closeTargets = modal.querySelectorAll('[data-action="close-modal"], .modal__close, .modal__overlay');
  function isSeen(){
    try { if (sessionStorage.getItem('skin_popup_seen') === '1') return true; } catch(e){}
    try { if (localStorage.getItem('themePopup')) return true; } catch(e){}
    return false;
  }
  function markSeen(){
    try { sessionStorage.setItem('skin_popup_seen', '1'); } catch(e){}
    try { localStorage.setItem('themePopup', 'true'); } catch(e){}
  }
  function openModal() {
    if (isSeen()) return;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-visible');
    document.documentElement.classList.add('no-scroll');
    document.body.classList.add('no-scroll');
    markSeen();
  }
  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-visible');
    document.documentElement.classList.remove('no-scroll');
    document.body.classList.remove('no-scroll');
    markSeen();
  }
  closeTargets.forEach(function(btn) { btn.addEventListener('click', closeModal); });
  setTimeout(openModal, 1800);
});


/* v28: cart quantity, AJAX add-to-cart and collection search fixes */
(function() {
  function updateCartBadges(count) {
    document.querySelectorAll('.skin-header__badge, .header__cart-count').forEach(function(badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? '' : 'none';
    });
  }

  function refreshCartCount() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(response) { return response.ok ? response.json() : null; })
      .then(function(cart) {
        if (cart && typeof cart.item_count === 'number') updateCartBadges(cart.item_count);
        return cart;
      })
      .catch(function() {});
  }

  function addFormToCart(form, button) {
    if (!form || form.dataset.skinAjaxAdding === 'true') return;
    form.dataset.skinAjaxAdding = 'true';
    var originalText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adicionando...';
    }

    fetch((window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }).then(function(response) {
      if (!response.ok) throw new Error('cart add failed');
      return response.json();
    }).then(function() {
      if (button) button.textContent = 'Adicionado!';
      return refreshCartCount();
    }).then(function() {
      document.dispatchEvent(new CustomEvent('skin:cart:added', { bubbles: true, detail: { form: form } }));
      setTimeout(function() {
        if (button) {
          button.disabled = false;
          button.textContent = originalText || 'Adicionar';
        }
        form.dataset.skinAjaxAdding = 'false';
      }, 1200);
    }).catch(function() {
      if (button) {
        button.disabled = false;
        button.textContent = originalText || 'Adicionar';
      }
      form.dataset.skinAjaxAdding = 'false';
    });
  }

  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!form || !form.matches('.skin-product__form, .product-card-form')) return;
    event.preventDefault();
    event.stopPropagation();
    var button = form.querySelector('button[type="submit"], .skin-product__button, .btn-add');
    addFormToCart(form, button);
  }, true);

  document.addEventListener('click', function(event) {
    if (window.theme && window.theme.cartType !== 'page') return;
    var control = event.target.closest('[data-section-type="cart"] .quantity-selector__button, [data-section-type="cart"] .line-item__quantity-remove');
    if (!control) return;
    var line = parseInt(control.getAttribute('data-line'), 10);
    var quantity = parseInt(control.getAttribute('data-quantity'), 10);
    if (!line || isNaN(quantity)) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    control.disabled = true;
    fetch((window.routes && window.routes.cartChangeUrl ? window.routes.cartChangeUrl : '/cart/change') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
    }).then(function(response) {
      if (!response.ok) throw new Error('cart change failed');
      return response.json();
    }).then(function(cart) {
      if (cart && typeof cart.item_count === 'number') updateCartBadges(cart.item_count);
      window.location.reload();
    }).catch(function() {
      var href = control.getAttribute('data-href');
      if (href) window.location.href = href;
      else window.location.reload();
    });
  }, true);

  document.addEventListener('change', function(event) {
    if (window.theme && window.theme.cartType !== 'page') return;
    var input = event.target.closest('[data-section-type="cart"] .quantity-selector__value');
    if (!input) return;
    var line = parseInt(input.getAttribute('data-line'), 10);
    var quantity = Math.max(1, parseInt(input.value, 10) || 1);
    if (!line) return;
    fetch((window.routes && window.routes.cartChangeUrl ? window.routes.cartChangeUrl : '/cart/change') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function() { window.location.reload(); }).catch(function() { window.location.reload(); });
  }, true);

  function normalizeText(value) {
    return (value || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }

  function initCollectionSearch(root) {
    if (!root || root.dataset.skinSearchFixReady === 'true') return;
    root.dataset.skinSearchFixReady = 'true';
    var input = root.querySelector('[data-skin-search-input]');
    var grid = root.querySelector('[data-skin-products-grid]');
    var sort = root.querySelector('[data-skin-sort-select]');
    var empty = root.querySelector('.skin-collection-no-results');
    if (!input || !grid) return;

    function cards() {
      return Array.prototype.slice.call(grid.querySelectorAll('[data-skin-product-card], .product-item.product-card, .skin-placeholder-product-card, .skin-placeholder-card'));
    }

    function titleOf(card) {
      var title = card.getAttribute('data-skin-title') || card.getAttribute('data-product-title') || card.getAttribute('data-title');
      var titleEl = card.querySelector('.product-title, .product-item__title, [data-skin-card-title]');
      return normalizeText(title || (titleEl ? titleEl.textContent : card.textContent));
    }

    function priceOf(card) {
      var raw = card.getAttribute('data-skin-price') || card.getAttribute('data-price') || '0';
      var num = parseInt(raw, 10);
      return isNaN(num) ? 0 : num;
    }

    function apply() {
      var term = normalizeText(input.value);
      var list = cards();
      var mode = sort ? sort.value : '';
      if (mode) {
        list.sort(function(a, b) {
          if (mode === 'price-ascending') return priceOf(a) - priceOf(b);
          if (mode === 'price-descending') return priceOf(b) - priceOf(a);
          if (mode === 'title-descending') return titleOf(b).localeCompare(titleOf(a));
          return titleOf(a).localeCompare(titleOf(b));
        }).forEach(function(card) { grid.appendChild(card); });
      }

      var visible = 0;
      list.forEach(function(card) {
        var match = !term || titleOf(card).indexOf(term) !== -1;
        card.hidden = !match;
        card.style.display = match ? '' : 'none';
        if (match) visible += 1;
      });
      if (empty) empty.classList.toggle('is-visible', visible === 0);
    }

    ['input', 'keyup', 'search', 'change'].forEach(function(name) { input.addEventListener(name, apply); });
    if (sort) sort.addEventListener('change', apply);
    apply();
  }

  function bootCollectionSearch() {
    document.querySelectorAll('.skin-collection-page').forEach(initCollectionSearch);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootCollectionSearch);
  else bootCollectionSearch();
  window.addEventListener('load', bootCollectionSearch);
  document.addEventListener('shopify:section:load', bootCollectionSearch);
})();


/* v29 robust cart/add/search fixes */
(function(){
  function cartAddUrl(){ return ((window.routes && window.routes.cartAddUrl) || '/cart/add') + '.js'; }
  function cartChangeUrl(){ return ((window.routes && window.routes.cartChangeUrl) || '/cart/change') + '.js'; }
  function updateBadges(count){
    document.querySelectorAll('.skin-header__badge, .header__cart-count, .cart-count-bubble, [data-cart-count]').forEach(function(el){
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }
  function refreshCount(){
    return fetch('/cart.js', { credentials:'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(cart){ if(cart && typeof cart.item_count === 'number') updateBadges(cart.item_count); return cart; })
      .catch(function(){});
  }
  function formAdd(form, button){
    if(!form || form.dataset.skinV29Adding === 'true') return false;
    form.dataset.skinV29Adding = 'true';
    var original = button ? button.textContent : '';
    if(button){ button.disabled = true; button.textContent = 'Adicionando...'; }
    fetch(cartAddUrl(), {
      method:'POST',
      credentials:'same-origin',
      headers:{ 'X-Requested-With':'XMLHttpRequest' },
      body:new FormData(form)
    }).then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(item){
        var qty = 1;
        try { qty = parseInt(new FormData(form).get('quantity'), 10) || 1; } catch(e) {}
        if(button){ button.textContent = 'Adicionado!'; }
        document.dispatchEvent(new CustomEvent('skin:cart:added', { bubbles:true, detail:{ form:form } }));
        form.dispatchEvent(new CustomEvent('product:added', { bubbles:true, detail:{ variant:item, quantity:qty, button:button, form:form } }));
        setTimeout(function(){
          if(button){ button.disabled = false; button.textContent = original || 'ADICIONAR'; }
          form.dataset.skinV29Adding = 'false';
        }, 1200);
      })
      .catch(function(){
        if(button){ button.disabled=false; button.textContent = original || 'ADICIONAR'; }
        form.dataset.skinV29Adding = 'false';
      });
    return false;
  }
  window.skinAddToCart = function(event, button){
    if(event){ event.preventDefault(); event.stopPropagation(); if(event.stopImmediatePropagation) event.stopImmediatePropagation(); }
    var form = button && button.closest('form');
    return formAdd(form, button);
  };
  document.addEventListener('click', function(event){
    var btn = event.target.closest('.product-card-form button[type="submit"], .skin-product__form button[type="submit"]');
    if(!btn) return;
    window.skinAddToCart(event, btn);
  }, true);
  document.addEventListener('submit', function(event){
    var form = event.target;
    if(!form || !form.matches('.product-card-form, .skin-product__form')) return;
    event.preventDefault(); event.stopPropagation(); if(event.stopImmediatePropagation) event.stopImmediatePropagation();
    formAdd(form, form.querySelector('button[type="submit"]'));
  }, true);

  window.skinCartChange = function(event, control){
    if(window.theme && window.theme.cartType !== 'page') return true;
    if(event){ event.preventDefault(); event.stopPropagation(); if(event.stopImmediatePropagation) event.stopImmediatePropagation(); }
    if(!control) return false;
    var line = parseInt(control.getAttribute('data-line'), 10);
    var quantity = parseInt(control.getAttribute('data-quantity'), 10);
    if(!line || isNaN(quantity)) return false;
    control.disabled = true;
    fetch(cartChangeUrl(), {
      method:'POST',
      credentials:'same-origin',
      headers:{ 'Content-Type':'application/json', 'X-Requested-With':'XMLHttpRequest' },
      body:JSON.stringify({ line:line, quantity:Math.max(0, quantity) })
    }).then(function(r){ if(!r.ok) throw new Error('change failed'); return r.json(); })
      .then(function(cart){ if(cart && typeof cart.item_count==='number') updateBadges(cart.item_count); window.location.reload(); })
      .catch(function(){ var href = control.getAttribute('data-href'); if(href) window.location.href = href; else window.location.reload(); });
    return false;
  };
  document.addEventListener('click', function(event){
    if (window.theme && window.theme.cartType !== 'page') return;
    var control = event.target.closest('[data-section-type="cart"] .quantity-selector__button, [data-section-type="cart"] .line-item__quantity-remove');
    if(control) window.skinCartChange(event, control);
  }, true);

  function normalize(v){ return (v || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim(); }
  function filterCollection(root){
    if(!root) return;
    var input = root.querySelector('[data-skin-search-input]');
    var grid = root.querySelector('[data-skin-products-grid]');
    var empty = root.querySelector('.skin-collection-no-results');
    if(!grid) return;
    var term = normalize(input ? input.value : '');
    var visible = 0;
    Array.prototype.slice.call(grid.querySelectorAll('[data-skin-product-card], .product-item.product-card, .skin-placeholder-product-card')).forEach(function(card){
      var title = normalize(card.getAttribute('data-skin-title') || card.getAttribute('data-product-title') || card.getAttribute('data-title') || (card.querySelector('.product-title,.product-item__title') || {}).textContent || card.textContent);
      var ok = !term || title.indexOf(term) !== -1;
      card.hidden = !ok;
      card.style.display = ok ? '' : 'none';
      if(ok) visible++;
    });
    if(empty) empty.classList.toggle('is-visible', visible === 0);
  }
  document.addEventListener('input', function(event){
    var input = event.target.closest('[data-skin-search-input]');
    if(input) filterCollection(input.closest('.skin-collection-page'));
  }, true);
  document.addEventListener('keyup', function(event){
    var input = event.target.closest('[data-skin-search-input]');
    if(input) filterCollection(input.closest('.skin-collection-page'));
  }, true);
})();


/* v39 robust cart, collection search, mobile header search and login fixes */
(function(){
  function route(name, fallback){ return (window.routes && window.routes[name]) || fallback; }
  function updateBadges(count){
    document.querySelectorAll('.skin-header__badge, .header__cart-count, .cart-count-bubble, [data-cart-count]').forEach(function(el){
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }
  function refreshCart(){
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(cart){ if(cart && typeof cart.item_count === 'number') updateBadges(cart.item_count); return cart; })
      .catch(function(){});
  }
  function addForm(form, button){
    if(!form || form.dataset.skinV39Adding === 'true') return false;
    form.dataset.skinV39Adding = 'true';
    var original = button ? button.textContent : '';
    if(button){ button.disabled = true; button.textContent = 'Adicionando...'; }
    fetch(route('cartAddUrl','/cart/add') + '.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form)
    }).then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(item){
        var qty = 1;
        try { qty = parseInt(new FormData(form).get('quantity'), 10) || 1; } catch(e) {}
        if(button){ button.textContent = 'Adicionado!'; }
        document.dispatchEvent(new CustomEvent('skin:cart:added', { bubbles:true, detail:{ form:form } }));
        form.dispatchEvent(new CustomEvent('product:added', { bubbles:true, detail:{ variant:item, quantity:qty, button:button, form:form } }));
        setTimeout(function(){
          if(button){ button.disabled = false; button.textContent = original || 'ADICIONAR'; }
          form.dataset.skinV39Adding = 'false';
        }, 1200);
      })
      .catch(function(){
        if(button){ button.disabled=false; button.textContent = original || 'ADICIONAR'; }
        form.dataset.skinV39Adding='false';
      });
    return false;
  }
  window.skinAddToCart = function(event, button){
    if(event){ event.preventDefault(); event.stopPropagation(); if(event.stopImmediatePropagation) event.stopImmediatePropagation(); }
    var form = button && button.closest('form');
    return addForm(form, button);
  };
  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form || !form.matches('.product-card-form, .skin-product__form')) return;
    e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation) e.stopImmediatePropagation();
    addForm(form, form.querySelector('button[type="submit"], .btn-add, .skin-product__button'));
  }, true);
  document.addEventListener('click', function(e){
    var button = e.target.closest('.product-card-form button[type="submit"], .skin-product__form button[type="submit"], .btn-add[data-action="add-to-cart"]');
    if(!button) return;
    var form = button.closest('form');
    if(!form || (!form.matches('.product-card-form') && !form.matches('.skin-product__form'))) return;
    window.skinAddToCart(e, button);
  }, true);

  window.skinCartChange = function(event, control){
    if(window.theme && window.theme.cartType !== 'page') return true;
    if(event){ event.preventDefault(); event.stopPropagation(); if(event.stopImmediatePropagation) event.stopImmediatePropagation(); }
    if(!control) return false;
    var line = parseInt(control.getAttribute('data-line'), 10);
    var qty = control.getAttribute('data-quantity');
    if(qty === null && control.classList.contains('quantity-selector__value')) qty = control.value;
    qty = Math.max(0, parseInt(qty, 10) || 0);
    if(!line) return false;
    fetch(route('cartChangeUrl','/cart/change') + '.js', {
      method:'POST', credentials:'same-origin', headers:{ 'Content-Type':'application/json', 'X-Requested-With':'XMLHttpRequest' }, body: JSON.stringify({ line: line, quantity: qty })
    }).then(function(r){ if(!r.ok) throw new Error('change failed'); return r.json(); })
      .then(function(cart){ if(cart && typeof cart.item_count==='number') updateBadges(cart.item_count); window.location.reload(); })
      .catch(function(){ var href = control.getAttribute('data-href'); if(href) window.location.href = href; else window.location.reload(); });
    return false;
  };
  document.addEventListener('click', function(e){
    if (window.theme && window.theme.cartType !== 'page') return;
    var control = e.target.closest('[data-section-type="cart"] .quantity-selector__button, [data-section-type="cart"] .line-item__quantity-remove');
    if(control) window.skinCartChange(e, control);
  }, true);
  document.addEventListener('change', function(e){
    if (window.theme && window.theme.cartType !== 'page') return;
    var input = e.target.closest('[data-section-type="cart"] .quantity-selector__value');
    if(input) window.skinCartChange(e, input);
  }, true);

  function normalize(v){ return (v || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim(); }
  function collectionFilter(root){
    if(!root) return;
    var input = root.querySelector('[data-skin-search-input]');
    var grid = root.querySelector('[data-skin-products-grid]');
    var empty = root.querySelector('.skin-collection-no-results');
    var sort = root.querySelector('[data-skin-sort-select]');
    if(!grid) return;
    var term = normalize(input ? input.value : '');
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-skin-product-card], .product-item.product-card, .skin-placeholder-product-card'));
    var mode = sort ? sort.value : '';
    if(mode){
      cards.sort(function(a,b){
        var ta = normalize(a.getAttribute('data-skin-title') || (a.querySelector('.product-title,.product-item__title')||{}).textContent || '');
        var tb = normalize(b.getAttribute('data-skin-title') || (b.querySelector('.product-title,.product-item__title')||{}).textContent || '');
        var pa = parseInt(a.getAttribute('data-skin-price') || a.getAttribute('data-price') || '0', 10) || 0;
        var pb = parseInt(b.getAttribute('data-skin-price') || b.getAttribute('data-price') || '0', 10) || 0;
        if(mode === 'price-ascending') return pa-pb;
        if(mode === 'price-descending') return pb-pa;
        if(mode === 'title-descending') return tb.localeCompare(ta);
        return ta.localeCompare(tb);
      }).forEach(function(card){ grid.appendChild(card); });
    }
    var visible=0;
    cards.forEach(function(card){
      var title = normalize(card.getAttribute('data-skin-title') || card.getAttribute('data-product-title') || (card.querySelector('.product-title,.product-item__title')||{}).textContent || card.textContent);
      var ok = !term || title.indexOf(term) !== -1;
      card.hidden = !ok; card.style.display = ok ? '' : 'none'; if(ok) visible++;
    });
    if(empty) empty.classList.toggle('is-visible', visible === 0);
  }
  function bootCollections(){
    document.querySelectorAll('.skin-collection-page').forEach(function(root){
      var input = root.querySelector('[data-skin-search-input]');
      var sort = root.querySelector('[data-skin-sort-select]');
      var q = new URLSearchParams(window.location.search).get('q');
      if(input && q && !input.value) input.value = q;
      if(input && !input.dataset.skinV39Bound){ ['input','keyup','search','change'].forEach(function(ev){ input.addEventListener(ev, function(){ collectionFilter(root); }); }); input.dataset.skinV39Bound='true'; }
      if(sort && !sort.dataset.skinV39Bound){ sort.addEventListener('change', function(){ collectionFilter(root); }); sort.dataset.skinV39Bound='true'; }
      collectionFilter(root);
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootCollections); else bootCollections();
  window.addEventListener('load', bootCollections);
  document.addEventListener('shopify:section:load', bootCollections);

  document.addEventListener('click', function(e){
    var account = e.target.closest('.skin-header__icon[aria-label="Minha conta"]');
    if(!account) return;
    var href = account.getAttribute('href');
    if(href){ e.stopPropagation(); window.location.href = href; }
  }, true);
})();


/* v40 final: login/account click fallback and collection search submit */
(function(){
  document.addEventListener('click', function(e){
    var account = e.target.closest('a[aria-label="Minha conta"], a[href*="/account"], .skin-header__account');
    if(!account) return;
    var href = account.getAttribute('href');
    if(href){ e.preventDefault(); e.stopPropagation(); window.location.href = href; }
  }, true);
  document.addEventListener('keydown', function(e){
    var input = e.target.closest && e.target.closest('[data-skin-search-input]');
    if(input && e.key === 'Enter') { e.preventDefault(); input.dispatchEvent(new Event('input', {bubbles:true})); }
  }, true);
})();


/* v41 final robust collection search and account/mobile search fallback */
(function(){
  function normalize(value){ return (value || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').trim(); }
  function filter(root){
    if(!root) return;
    var input = root.querySelector('[data-skin-search-input]');
    var grid = root.querySelector('[data-skin-products-grid]');
    var empty = root.querySelector('.skin-collection-no-results');
    if(!input || !grid) return;
    var term = normalize(input.value);
    var visible = 0;
    Array.prototype.slice.call(grid.querySelectorAll('[data-skin-product-card], .product-item.product-card, .skin-placeholder-product-card')).forEach(function(card){
      var titleEl = card.querySelector('.product-title, .product-item__title, [data-skin-card-title]');
      var title = normalize(card.getAttribute('data-skin-title') || card.getAttribute('data-title') || card.getAttribute('data-product-title') || (titleEl && titleEl.textContent) || card.textContent);
      var ok = !term || title.indexOf(term) !== -1;
      card.classList.toggle('is-skin-filter-hidden', !ok);
      card.hidden = !ok;
      if(ok) visible++;
    });
    if(empty) empty.classList.toggle('is-visible', visible === 0);
  }
  function boot(){
    document.querySelectorAll('.skin-collection-page').forEach(function(root){
      var input = root.querySelector('[data-skin-search-input]');
      if(!input || input.dataset.v41FinalSearch) { filter(root); return; }
      var q = new URLSearchParams(window.location.search).get('q') || '';
      if(q && !input.value) input.value = q;
      ['input','keyup','change','search'].forEach(function(type){ input.addEventListener(type, function(){ filter(root); }, true); });
      input.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); filter(root); } }, true);
      var icon = root.querySelector('.skin-collection-search__icon');
      if(icon) icon.addEventListener('click', function(e){ e.preventDefault(); input.focus(); filter(root); }, true);
      input.dataset.v41FinalSearch = 'true';
      filter(root);
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
})();


/* v42: último fallback de busca de coleção */
(function(){
  function normalize(v){ return (v || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim(); }
  function apply(input){
    var root = input && input.closest('.skin-collection-page');
    var grid = root && root.querySelector('[data-skin-products-grid]');
    var empty = root && root.querySelector('.skin-collection-no-results');
    if(!root || !grid) return;
    var term = normalize(input.value);
    var visible = 0;
    grid.querySelectorAll('[data-skin-product-card], .product-item.product-card, .skin-placeholder-product-card').forEach(function(card){
      var titleEl = card.querySelector('.product-title, .product-item__title, [data-skin-card-title]');
      var title = normalize(card.getAttribute('data-skin-title') || card.getAttribute('data-title') || card.getAttribute('data-product-title') || (titleEl && titleEl.textContent) || card.textContent);
      var ok = !term || title.indexOf(term) !== -1;
      card.classList.toggle('is-skin-filter-hidden', !ok);
      card.hidden = !ok;
      card.style.setProperty('display', ok ? '' : 'none', ok ? '' : 'important');
      if(ok) visible++;
    });
    if(empty) empty.classList.toggle('is-visible', visible === 0);
  }
  document.addEventListener('input', function(e){ var input = e.target.closest && e.target.closest('[data-skin-search-input]'); if(input) apply(input); }, true);
  document.addEventListener('keyup', function(e){ var input = e.target.closest && e.target.closest('[data-skin-search-input]'); if(input) apply(input); }, true);
  document.addEventListener('click', function(e){ var icon = e.target.closest && e.target.closest('.skin-collection-search__icon'); if(!icon) return; var input = icon.closest('.skin-collection-search').querySelector('[data-skin-search-input]'); if(input){ e.preventDefault(); input.focus(); apply(input); } }, true);
  window.addEventListener('load', function(){ document.querySelectorAll('[data-skin-search-input]').forEach(apply); });
})();


/* v44 final: busca de coleção à prova de scripts antigos */
(function(){
  function norm(v){ return (v || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim(); }
  function filter(root){
    if(!root) return;
    var input = root.querySelector('[data-skin-search-input]');
    var grid = root.querySelector('[data-skin-products-grid]');
    var empty = root.querySelector('.skin-collection-no-results');
    if(!input || !grid) return;
    var term = norm(input.value);
    var visible = 0;
    Array.prototype.slice.call(grid.querySelectorAll('[data-skin-product-card], .product-item.product-card, .skin-placeholder-product-card, .skin-products-grid__item')).forEach(function(card){
      var titleEl = card.querySelector('.product-title, .product-item__title, [data-skin-card-title]');
      var title = norm(card.getAttribute('data-skin-title') || card.getAttribute('data-title') || card.getAttribute('data-product-title') || (titleEl && titleEl.textContent) || card.textContent);
      var ok = !term || title.indexOf(term) !== -1;
      card.classList.toggle('is-skin-filter-hidden', !ok);
      card.hidden = !ok;
      if(ok){ card.style.removeProperty('display'); visible++; }
      else { card.style.setProperty('display','none','important'); }
    });
    if(empty) empty.classList.toggle('is-visible', visible === 0);
  }
  function boot(){
    document.querySelectorAll('.skin-collection-page').forEach(function(root){
      var input = root.querySelector('[data-skin-search-input]');
      if(!input) return;
      var q = new URLSearchParams(window.location.search).get('q') || new URLSearchParams(window.location.search).get('filter') || '';
      if(q && !input.value) input.value = q;
      if(!input.dataset.v44Bound){
        ['input','keyup','change','search','paste'].forEach(function(type){ input.addEventListener(type, function(){ setTimeout(function(){ filter(root); }, 0); }, true); });
        input.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); filter(root); } }, true);
        var icon = root.querySelector('.skin-collection-search__icon');
        if(icon) icon.addEventListener('click', function(e){ e.preventDefault(); input.focus(); filter(root); }, true);
        input.dataset.v44Bound = 'true';
      }
      filter(root);
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
})();

/* v47: corta títulos mobile dinamicamente, usando o máximo da segunda linha */
(function(){
  function isMobile(){ return (window.innerWidth || document.documentElement.clientWidth || 1024) <= 640; }
  var selector = [
    '.skin-products-grid .product-title',
    '.skin-products-grid .product-item__title',
    '.skin-product__recommendations .product-title',
    '.skin-product__recommendations .product-item__title',
    '.skin-home__tiktok-carousel .product-title',
    '.skin-home__tiktok-carousel .product-item__title'
  ].join(',');
  function clean(text){ return (text || '').replace(/\s+/g,' ').trim(); }
  function setStyle(el, prop, value){ el.style.setProperty(prop, value, 'important'); }
  function fits(el, maxHeight){ return el.scrollHeight <= maxHeight + 1 && el.clientHeight <= maxHeight + 1; }
  function clamp(el){
    if(!el.dataset.skinFullTitle) el.dataset.skinFullTitle = clean(el.textContent);
    var full = el.dataset.skinFullTitle;
    el.textContent = full;
    el.title = full;
    if(!isMobile()){
      ['display','height','min-height','max-height','overflow','white-space','text-overflow'].forEach(function(prop){ el.style.removeProperty(prop); });
      el.textContent = full;
      return;
    }
    setStyle(el,'display','block');
    setStyle(el,'white-space','normal');
    setStyle(el,'overflow','hidden');
    setStyle(el,'text-overflow','clip');
    var cs = window.getComputedStyle(el);
    var fontSize = parseFloat(cs.fontSize) || 12;
    var lineHeight = parseFloat(cs.lineHeight);
    if(!lineHeight || isNaN(lineHeight)) lineHeight = Math.round(fontSize * 1.32);
    var maxHeight = Math.ceil(lineHeight * 2);
    setStyle(el,'height', maxHeight + 'px');
    setStyle(el,'min-height', maxHeight + 'px');
    setStyle(el,'max-height', maxHeight + 'px');
    if(fits(el, maxHeight)) return;
    var lo = 0, hi = full.length, best = '';
    while(lo <= hi){
      var mid = Math.floor((lo + hi) / 2);
      var candidate = full.slice(0, Math.max(0, mid)).replace(/[\s\-+]+$/,'') + '...';
      el.textContent = candidate;
      if(fits(el, maxHeight)) { best = candidate; lo = mid + 1; }
      else { hi = mid - 1; }
    }
    el.textContent = best || (full.slice(0, 24).replace(/[\s\-+]+$/,'') + '...');
  }
  function apply(){
    document.querySelectorAll(selector).forEach(clamp);
  }
  function schedule(){ clearTimeout(window.__skinV47TitleTimer); window.__skinV47TitleTimer = setTimeout(apply, 80); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  window.addEventListener('load', apply);
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', apply);
  document.addEventListener('lazyloaded', schedule);
  setTimeout(apply, 350);
  setTimeout(apply, 1000);
})();

/* v76: prevent isolated final words in mobile section titles */
(function(){
  var selector = [
    '.section__title',
    '.featured-collection__title',
    '.skin-featured__title',
    '.skin-community-title',
    '.skin-hero__title',
    '.skin-home__hero-title',
    '.skin-home__title',
    '.skin-home__blue-title',
    '.skin-home__testimonials-title',
    '.skin-product__section-title',
    '.skin-product__story-title',
    '.skin-product__review-form h3',
    '.skin-collection-hero__title',
    '.skin-popup__title'
  ].join(',');

  function isMobile(){
    return (window.innerWidth || document.documentElement.clientWidth || 1024) <= 640;
  }

  function hasElementChild(el){
    for(var i = 0; i < el.childNodes.length; i++){
      if(el.childNodes[i].nodeType === 1) return true;
    }
    return false;
  }

  function apply(){
    var mobile = isMobile();
    var items = document.querySelectorAll(selector);
    Array.prototype.forEach.call(items, function(el){
      if(!el || hasElementChild(el)) return;
      if(!el.getAttribute('data-skin-v76-title')){
        el.setAttribute('data-skin-v76-title', el.textContent || '');
      }
      var original = el.getAttribute('data-skin-v76-title') || '';
      var clean = original.replace(/\s+/g, ' ').trim();
      if(!mobile){
        el.textContent = original;
        return;
      }
      var words = clean.split(' ');
      if(words.length >= 3){
        words[words.length - 2] = words[words.length - 2] + '\u00a0' + words[words.length - 1];
        words.pop();
        el.textContent = words.join(' ');
      } else {
        el.textContent = clean;
      }
    });
  }

  function schedule(){
    window.clearTimeout(window.__skinV76TitleTimer);
    window.__skinV76TitleTimer = window.setTimeout(apply, 120);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  window.addEventListener('load', apply);
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', apply);
})();


/* ================================================================
   RUVO - Customizações v1
   Slideshow | Carrinho | "Skin Tone"→"Ruvo" | Footer links
   ================================================================ */


/* ─── 1. SLIDESHOW HOME + BANNER TODOS OS PRODUTOS ─── */
(function () {
  'use strict';

  /* Obtém a URL base dos assets a partir da src do próprio custom.js */
  function assetBase() {
    var el = document.querySelector('script[src*="custom.js"]');
    if (el && el.src) return el.src.replace(/\/[^/]*\?.*$/, '/').replace(/\/[^/]*$/, '/');
    return '';
  }

  var BASE = assetBase();

  function assetUrl(name) { return BASE + name; }

  /* ── Slides da home (2 banners em carousel) ──
     IMPORTANTE: Faça upload das imagens abaixo no painel Shopify > Temas > Editar código > Assets:
       banner-home-desktop.jpg    (1_PC.png)
       banner-home-mobile.jpg     (1_mobile.png)
       banner-home-2-desktop.jpg  (2_PC.png)
       banner-home-2-mobile.jpg   (2_mobile.png)
  */
  var HOME_SLIDES = [
    {
      desktop: 'banner-home-desktop.jpg',
      mobile:  'banner-home-mobile.jpg',
      alt:     'Máscara Ruvo – Hidratação profunda desde o primeiro uso'
    },
    {
      desktop: 'banner-home-2-desktop.jpg',
      mobile:  'banner-home-2-mobile.jpg',
      alt:     'Tônico de Crescimento Ruvo'
    }
  ];

  /* ── Banner da página Todos os Produtos ──
     IMPORTANTE: Faça upload das imagens abaixo no painel Shopify > Assets:
       banner-produtos-desktop.jpg   (Todos_os_produtos_PC_.png)
       banner-produtos-mobile.jpg    (Todos_os_produtos_mobile_.png)
  */
  var PRODUTOS_BANNER = {
    desktop: 'banner-produtos-desktop.jpg',
    mobile:  'banner-produtos-mobile.jpg',
    alt:     'Conheça a linha Ruvo – Força e Crescimento'
  };

  /* Detecta a página atual */
  function isHomePage() {
    return document.body.classList.contains('template-index') ||
           window.location.pathname === '/' ||
           window.location.pathname === '';
  }
  function isAllProductsPage() {
    var p = window.location.pathname.toLowerCase();
    return document.body.classList.contains('template-collection') &&
           (p.indexOf('/all') !== -1 || p.indexOf('/todo') !== -1 ||
            p.indexOf('/produto') !== -1 || p.indexOf('/colecao') !== -1 ||
            p.indexOf('/colecção') !== -1);
  }

  /* Monta HTML do slideshow */
  function buildSlideshow(slides) {
    var slideHtml = slides.map(function (s, i) {
      return '<div class="ruvo-slide' + (i === 0 ? ' is-active' : '') + '">' +
        '<picture>' +
        '<source media="(max-width:767px)" srcset="' + assetUrl(s.mobile) + '">' +
        '<img src="' + assetUrl(s.desktop) + '" alt="' + s.alt + '" loading="' + (i === 0 ? 'eager' : 'lazy') + '">' +
        '</picture></div>';
    }).join('');

    var ctrlHtml = slides.length > 1
      ? '<div class="ruvo-dots">' +
        slides.map(function (_, i) {
          return '<button class="ruvo-dot' + (i === 0 ? ' is-active' : '') + '" data-ruvo-i="' + i + '" aria-label="Slide ' + (i + 1) + '"></button>';
        }).join('') +
        '</div>' +
        '<button class="ruvo-arr ruvo-arr--prev" aria-label="Slide anterior">&#8249;</button>' +
        '<button class="ruvo-arr ruvo-arr--next" aria-label="Próximo slide">&#8250;</button>'
      : '';

    return '<div class="ruvo-slideshow" data-ruvo-slideshow>' + slideHtml + ctrlHtml + '</div>';
  }

  /* Monta HTML do banner único */
  function buildBanner(b) {
    return '<div class="ruvo-banner" data-ruvo-banner>' +
      '<picture>' +
      '<source media="(max-width:767px)" srcset="' + assetUrl(b.mobile) + '">' +
      '<img src="' + assetUrl(b.desktop) + '" alt="' + b.alt + '" loading="eager">' +
      '</picture></div>';
  }

  /* Inicializa os controles do slideshow */
  function initControls(ss) {
    var slides = ss.querySelectorAll('.ruvo-slide');
    var dots   = ss.querySelectorAll('.ruvo-dot');
    var total  = slides.length;
    if (!total) return;
    var cur = 0, timer;

    function show(n) {
      slides[cur].classList.remove('is-active');
      if (dots[cur]) dots[cur].classList.remove('is-active');
      cur = (n + total) % total;
      slides[cur].classList.add('is-active');
      if (dots[cur]) dots[cur].classList.add('is-active');
    }
    function play()  { timer = setInterval(function () { show(cur + 1); }, 5500); }
    function pause() { clearInterval(timer); }

    var prev = ss.querySelector('.ruvo-arr--prev');
    var next = ss.querySelector('.ruvo-arr--next');
    if (prev) prev.addEventListener('click', function () { pause(); show(cur - 1); play(); });
    if (next) next.addEventListener('click', function () { pause(); show(cur + 1); play(); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { pause(); show(i); play(); });
    });

    /* Swipe touch */
    var tx = 0;
    ss.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    ss.addEventListener('touchend',   function (e) {
      var dx = tx - e.changedTouches[0].clientX;
      if (Math.abs(dx) > 45) { pause(); show(cur + (dx > 0 ? 1 : -1)); play(); }
    }, { passive: true });

    play();
  }

  /* Encontra ponto de inserção na página */
  function findInsertPoint(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  /* Slideshow home: gerenciado pelo Liquid em homepage-redesign.liquid (sem injeção JS) */
  /* Banner todos os produtos: gerenciado pelo Liquid em collection-template.liquid (sem injeção JS) */
  function inject() {
    /* Ambos os banners são renderizados diretamente pelo Liquid do tema - sem injeção via JS */
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject);
  else inject();
  window.addEventListener('load', inject);
  document.addEventListener('shopify:section:load', inject);
})();


/* ─── 2. CARRINHO – controlado pelo script final RUVO v3 ─── */
(function () {
  'use strict';
  /* Mantido como bloco neutro para não forçar /cart nem checkout. */
})();


/* ─── 3. SUBSTITUIR "Skin Tone" POR "Ruvo" EM TODO O SITE ─── */
(function () {
  'use strict';

  var TERMS = [
    'Skin Tone', 'skin tone', 'SKIN TONE', 'Skin tone',
    'SkinTone', 'skintone', 'skin-tone', 'Skin-Tone',
    'SKINTONE', 'SKIN-TONE'
  ];

  function replaceAll(str) {
    TERMS.forEach(function (t) {
      while (str.indexOf(t) !== -1) str = str.replace(t, 'Ruvo');
    });
    return str;
  }

  function walkText(node) {
    if (!node) return;
    if (node.nodeType === Node.TEXT_NODE) {
      var v = node.nodeValue;
      var replaced = replaceAll(v);
      if (replaced !== v) node.nodeValue = replaced;
    } else if (
      node.nodeType === Node.ELEMENT_NODE &&
      node.tagName !== 'SCRIPT' &&
      node.tagName !== 'STYLE' &&
      node.tagName !== 'CODE' &&
      node.tagName !== 'TEXTAREA'
    ) {
      node.childNodes.forEach(walkText);
    }
  }

  function replaceAttrs(root) {
    var attrs = ['alt', 'title', 'aria-label', 'placeholder', 'data-store-name', 'content'];
    root.querySelectorAll('*').forEach(function (el) {
      attrs.forEach(function (a) {
        var v = el.getAttribute(a);
        if (v && TERMS.some(function (t) { return v.indexOf(t) !== -1; })) {
          el.setAttribute(a, replaceAll(v));
        }
      });
    });
  }

  function run() {
    if (!document.body) return;
    walkText(document.body);
    replaceAttrs(document.body);
    document.title = replaceAll(document.title);
    /* Meta og:site_name */
    var siteName = document.querySelector('meta[property="og:site_name"]');
    if (siteName) siteName.setAttribute('content', replaceAll(siteName.getAttribute('content') || ''));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  /* Observador de mutação - desativado para evitar flash de navegação */
  /* A substituição roda uma vez no DOMContentLoaded e window.load */
})();


/* ─── 4. FOOTER LINKS – CASES PARA NOMES PARECIDOS ─── */
(function () {
  'use strict';

  /*
    Mapeamento: texto/slug normalizado → URL real.
    Adicione ou edite entradas conforme as páginas existirem na loja.
  */
  var LINK_MAP = {
    /* ── Políticas ── */
    'politica-de-privacidade'   : '/pages/politica-de-privacidade',
    'politica de privacidade'   : '/pages/politica-de-privacidade',
    'privacidade'               : '/pages/politica-de-privacidade',
    'privacy'                   : '/pages/politica-de-privacidade',
    'privacy-policy'            : '/pages/politica-de-privacidade',
    'politica privacidade'      : '/pages/politica-de-privacidade',

    'politica-de-troca'         : '/pages/politica-de-troca',
    'politica de troca'         : '/pages/politica-de-troca',
    'troca'                     : '/pages/politica-de-troca',
    'devolucao'                 : '/pages/politica-de-troca',
    'troca e devolucao'         : '/pages/politica-de-troca',
    'troca-e-devolucao'         : '/pages/politica-de-troca',
    'trocas e devolucoes'       : '/pages/politica-de-troca',
    'returns'                   : '/pages/politica-de-troca',
    'refund'                    : '/pages/politica-de-troca',
    'refund-policy'             : '/pages/politica-de-troca',

    'termos-de-uso'             : '/pages/termos-de-uso',
    'termos de uso'             : '/pages/termos-de-uso',
    'termos'                    : '/pages/termos-de-uso',
    'terms'                     : '/pages/termos-de-uso',
    'terms-of-service'          : '/pages/termos-de-uso',
    'termos e condicoes'        : '/pages/termos-de-uso',

    /* ── Suporte / Atendimento ── */
    'faq'                       : '/pages/faq',
    'perguntas-frequentes'      : '/pages/faq',
    'perguntas frequentes'      : '/pages/faq',
    'duvidas'                   : '/pages/faq',
    'duvidas-frequentes'        : '/pages/faq',
    'help'                      : '/pages/faq',
    'ajuda'                     : '/pages/faq',

    'contato'                   : '/pages/contato',
    'contact'                   : '/pages/contato',
    'fale-conosco'              : '/pages/contato',
    'fale conosco'              : '/pages/contato',
    'atendimento'               : '/pages/contato',
    'suporte'                   : '/pages/contato',

    /* ── Sobre / Empresa ── */
    'sobre'                     : '/pages/sobre',
    'sobre-nos'                 : '/pages/sobre',
    'sobre nos'                 : '/pages/sobre',
    'quem-somos'                : '/pages/sobre',
    'quem somos'                : '/pages/sobre',
    'about'                     : '/pages/sobre',
    'about-us'                  : '/pages/sobre',
    'nossa-historia'            : '/pages/sobre',
    'nossa historia'            : '/pages/sobre',

    /* ── Produtos / Coleções ── */
    'todos-os-produtos'         : '/collections/all',
    'todos os produtos'         : '/collections/all',
    'produtos'                  : '/collections/all',
    'products'                  : '/collections/all',
    'loja'                      : '/collections/all',
    'catalogo'                  : '/collections/all',
    'all'                       : '/collections/all',

    /* ── Rastreio / Pedido ── */
    'rastrear'                  : '/pages/rastreio',
    'rastreio'                  : '/pages/rastreio',
    'rastreamento'              : '/pages/rastreio',
    'track'                     : '/pages/rastreio',
    'meu-pedido'                : '/pages/rastreio',
    'meu pedido'                : '/pages/rastreio',
    'pedido'                    : '/pages/rastreio',
    'onde-esta-meu-pedido'      : '/pages/rastreio',
    'onde esta meu pedido'      : '/pages/rastreio',
  };

  function norm(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') /* remove acentos */
      .trim();
  }

  /* Tenta resolver um href ou texto em uma URL mapeada */
  function resolve(href, text) {
    /* Ignora links externos, âncoras, mailto, tel */
    if (!href || href.charAt(0) === '#' ||
        href.indexOf('//') !== -1 ||
        href.indexOf('mailto:') === 0 ||
        href.indexOf('tel:') === 0) return null;

    /* Extrai o slug do href */
    var slug = norm(href)
      .replace(/^\/+/, '')
      .replace(/^pages\/|^collections\/|^products\//, '');

    /* Tenta primeiro pelo slug do href, depois pelo texto */
    return LINK_MAP[slug] || LINK_MAP[norm(href)] ||
           LINK_MAP[norm(text)] || LINK_MAP[norm(text).replace(/\s+/g, '-')] ||
           null;
  }

  function fixLinks(root) {
    root = root || document;
    root.querySelectorAll(
      'footer a, .footer a, .skin-footer a, .site-footer a, ' +
      '.footer__links a, .footer__nav a, .footer__menu a, ' +
      '.footer__column a, .footer__block a'
    ).forEach(function (link) {
      var href = link.getAttribute('href');
      var text = link.textContent;
      var mapped = resolve(href, text);
      if (mapped && mapped !== href) {
        link.setAttribute('data-ruvo-orig', href);
        link.setAttribute('href', mapped);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { fixLinks(); });
  else fixLinks();
  window.addEventListener('load', function () { fixLinks(); });
  document.addEventListener('shopify:section:load', function () { fixLinks(); });
})();



/* ================================================================
   RUVO - Correções v2
   ================================================================ */

/* ─── CORREÇÃO: carrinho controlado pelo script final RUVO v3 ─── */
(function () {
  'use strict';
  /* Mantido como bloco neutro para não competir com a gaveta do carrinho. */
})();


/* ─── CORREÇÃO CEP: botão OK → texto "Calcular Frete" ─── */
(function () {
  function fixCepButton() {
    var buttons = document.querySelectorAll('#shipping-estimator .btn');
    buttons.forEach(function (btn) {
      if (btn.dataset.ruvoFixed) return;
      btn.dataset.ruvoFixed = 'true';
      if (btn.textContent.trim() === 'OK' || btn.textContent.trim() === 'ok') {
        btn.textContent = 'Calcular Frete';
      }
      /* Garante que o botão começa visível (o JS do tema o oculta em keyup) */
      btn.style.removeProperty('display');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixCepButton);
  else fixCepButton();
  window.addEventListener('load', fixCepButton);
  /* Aguarda abertura do collapsible */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.estimate-shipping__toggle')) {
      setTimeout(fixCepButton, 200);
    }
  });
})();


/* ─── CORREÇÃO SLIDESHOW: reinicia se slides estiverem todos visíveis ─── */
(function () {
  function repairSlideshow() {
    document.querySelectorAll('[data-ruvo-slideshow]').forEach(function (ss) {
      var slides = ss.querySelectorAll('.ruvo-slide');
      var hasActive = ss.querySelector('.ruvo-slide.is-active');
      if (!hasActive && slides.length) {
        slides[0].classList.add('is-active');
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', repairSlideshow);
  else repairSlideshow();
  window.addEventListener('load', repairSlideshow);
})();

/* ================================================================
   RUVO v3 - Carrinho sem reload + frete robusto + checkout Yampi/Shopify
   ================================================================ */
(function () {
  'use strict';

  var cartRequestInFlight = false;
  var openTimer = null;

  function route(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function isCartPage() {
    return window.theme && window.theme.pageType === 'cart' || document.body.classList.contains('template-cart') || window.location.pathname.replace(/\/$/, '') === '/cart';
  }

  function miniCart() {
    return document.getElementById('mini-cart');
  }

  function cartToggle() {
    return document.querySelector('[data-action="toggle-mini-cart"][aria-controls="mini-cart"], a[aria-label="Carrinho"][aria-controls="mini-cart"]');
  }

  function overlay() {
    return document.getElementById('overlay') || document.querySelector('.drawer__overlay');
  }

  function updateBadges(count) {
    document.querySelectorAll('.skin-header__badge, .header__cart-count, .cart-count-bubble, [data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function setCartBusy(busy) {
    var drawer = miniCart();
    var pageCart = document.querySelector('[data-section-type="cart"]');
    [drawer, pageCart].forEach(function (el) {
      if (!el) return;
      el.classList.toggle('ruvo-cart-updating', !!busy);
      el.setAttribute('aria-busy', busy ? 'true' : 'false');
    });
  }

  function openDrawer() {
    var drawer = miniCart();
    var toggle = cartToggle();
    if (!drawer || isCartPage()) return;

    drawer.setAttribute('aria-hidden', 'false');
    var form = drawer.querySelector('form');
    if (form) form.setAttribute('aria-hidden', 'false');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');

    var ov = overlay();
    if (ov) ov.style.display = 'block';
    document.body.classList.add('no-mobile-scroll');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var drawer = miniCart();
    var toggle = cartToggle();
    if (!drawer) return;

    drawer.setAttribute('aria-hidden', 'true');
    var form = drawer.querySelector('form');
    if (form) form.setAttribute('aria-hidden', 'true');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');

    var ov = overlay();
    if (ov) ov.style.display = 'none';
    document.body.classList.remove('no-mobile-scroll');
    document.documentElement.style.overflow = '';
  }

  function refreshCartJson() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') updateBadges(cart.item_count);
        return cart;
      })
      .catch(function () { return null; });
  }

  function refreshMiniCart(shouldOpen) {
    var drawer = miniCart();
    if (!drawer) return refreshCartJson();

    return fetch(route('cartUrl', '/cart') + '?view=mini-cart&timestamp=' + Date.now(), {
      credentials: 'same-origin',
      method: 'GET'
    })
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (html) {
        if (html) {
          var holder = document.createElement('div');
          holder.innerHTML = html;
          var fresh = holder.querySelector('#mini-cart');
          if (fresh) {
            var wasOpen = drawer.getAttribute('aria-hidden') === 'false';
            drawer.innerHTML = fresh.innerHTML;
            drawer.setAttribute('aria-hidden', shouldOpen || wasOpen ? 'false' : 'true');
            var form = drawer.querySelector('form');
            if (form) form.setAttribute('aria-hidden', shouldOpen || wasOpen ? 'false' : 'true');
          }
        }
        return refreshCartJson();
      })
      .then(function (cart) {
        if (shouldOpen) openDrawer();
        return cart;
      });
  }

  function refreshCartPage() {
    return fetch(route('cartUrl', '/cart') + '?timestamp=' + Date.now(), {
      credentials: 'same-origin',
      method: 'GET'
    })
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (html) {
        if (html) {
          var holder = document.createElement('div');
          holder.innerHTML = html;
          var fresh = holder.querySelector('[data-section-type="cart"]');
          var current = document.querySelector('[data-section-type="cart"]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        }
        return refreshCartJson();
      })
      .then(function (cart) {
        bootShippingEstimator();
        return cart;
      });
  }

  function quantityPayload(control) {
    if (!control) return null;

    var quantityRaw = control.getAttribute('data-quantity');
    if (quantityRaw === null && control.classList.contains('quantity-selector__value')) quantityRaw = control.value;
    var quantity = Math.max(0, parseInt(quantityRaw, 10));
    if (isNaN(quantity)) return null;

    var id = control.getAttribute('data-line-id');
    var line = control.getAttribute('data-line');

    if (id) return { id: id, quantity: quantity };
    if (line) return { line: parseInt(line, 10), quantity: quantity };
    return null;
  }

  function changeCart(control) {
    var payload = quantityPayload(control);
    if (!payload || cartRequestInFlight) return Promise.resolve(null);

    cartRequestInFlight = true;
    setCartBusy(true);

    return fetch(route('cartChangeUrl', '/cart/change') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart change failed');
        return response.json();
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') updateBadges(cart.item_count);
        return isCartPage() ? refreshCartPage() : refreshMiniCart(true);
      })
      .catch(function () {
        return refreshCartJson();
      })
      .then(function (cart) { return cart; })
      .finally(function () {
        cartRequestInFlight = false;
        setCartBusy(false);
      });
  }

  window.skinCartChange = function (event, control) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }
    changeCart(control);
    return false;
  };

  function scheduleOpenAfterAdd() {
    window.clearTimeout(openTimer);
    openTimer = window.setTimeout(function () {
      if (isCartPage()) {
        refreshCartPage();
        return;
      }

      if ((window.theme && window.theme.cartType === 'page') || !miniCart()) {
        window.location.href = route('cartUrl', '/cart');
        return;
      }

      refreshMiniCart(true);
    }, 80);
  }

  function toggleCollapsible(button, panel) {
    if (!button || !panel) return;
    var expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    panel.setAttribute('aria-hidden', expanded ? 'true' : 'false');

    if (expanded) {
      panel.style.height = '0px';
    } else {
      panel.style.height = 'auto';
      panel.style.overflow = 'visible';
    }
  }

  function formatCep(value) {
    var digits = String(value || '').replace(/\D/g, '').slice(0, 8);
    if (digits.length > 5) return digits.slice(0, 5) + '-' + digits.slice(5);
    return digits;
  }

  function calcShipping(cep) {
    var root = document.getElementById('shipping-estimator');
    if (!root) return;
    var digits = String(cep || '').replace(/\D/g, '');
    var list = root.querySelector('ul');
    var availability = root.querySelector('.ship-availability') || document.querySelector('.ship-availability');
    if (!list) return;

    list.style.display = 'block';
    list.innerHTML = '';

    if (digits.length !== 8) {
      list.innerHTML = '<li style="text-align:center;margin-bottom:0;padding-bottom:0;border-bottom:none;">Digite um CEP válido.</li>';
      if (availability) availability.style.display = 'none';
      return;
    }

    list.classList.add('loading');

    fetch('https://viacep.com.br/ws/' + digits + '/json/', { method: 'GET' })
      .then(function (response) { return response.ok ? response.json() : { erro: true }; })
      .then(function (json) {
        list.classList.remove('loading');
        if (json && json.erro) {
          list.innerHTML = '<li style="text-align:center;margin-bottom:0;padding-bottom:0;border-bottom:none;">Não foram encontradas formas de envio para o CEP informado.</li>';
          if (availability) availability.style.display = 'none';
          return;
        }
        list.innerHTML = '';
        var added = false;
        var freeName = window.ruvoShippingFreeName || 'Frete Grátis';
        var freeRange = window.ruvoShippingFreeRange || '5 - 12 dias úteis';
        var paidName = window.ruvoShippingPaidName || 'Entrega';
        var paidRange = window.ruvoShippingPaidRange || '5 - 12 dias úteis';
        var paidPrice = window.ruvoShippingPaidPrice || '';

        if (window.ruvoShippingActiveFree !== false) {
          list.insertAdjacentHTML('beforeend', '<li><span class="ship-price">Frete Grátis</span><span class="ship-interval">' + freeRange + '</span><span class="ship-name">' + freeName + '</span></li>');
          added = true;
        }
        if (window.ruvoShippingActivePaid) {
          list.insertAdjacentHTML('beforeend', '<li><span class="ship-price">' + paidPrice + '</span><span class="ship-interval">' + paidRange + '</span><span class="ship-name">' + paidName + '</span></li>');
          added = true;
        }
        if (!added) {
          list.insertAdjacentHTML('beforeend', '<li><span class="ship-price">Frete calculado no checkout</span><span class="ship-interval">Consulte o prazo na finalização</span><span class="ship-name">Entrega</span></li>');
        }
        if (availability) availability.style.display = 'block';
      })
      .catch(function () {
        list.classList.remove('loading');
        list.innerHTML = '<li style="text-align:center;margin-bottom:0;padding-bottom:0;border-bottom:none;">Não foi possível calcular o frete agora. Tente novamente.</li>';
        if (availability) availability.style.display = 'none';
      });
  }

  window.calcula = calcShipping;

  function bootShippingEstimator() {
    var root = document.getElementById('shipping-estimator');
    if (!root || root.dataset.ruvoShippingReady === 'true') return;
    root.dataset.ruvoShippingReady = 'true';

    var input = root.querySelector('.input-cep');
    var button = root.querySelector('.shipping-estimator__button, .btn');
    if (button) {
      button.textContent = 'Calcular frete';
      button.style.removeProperty('display');
      button.addEventListener('click', function (event) {
        event.preventDefault();
        calcShipping(input ? input.value : '');
      });
    }
    if (input) {
      input.addEventListener('input', function () {
        input.value = formatCep(input.value);
      });
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          calcShipping(input.value);
        }
      });
      input.addEventListener('blur', function () {
        input.value = formatCep(input.value);
      });
    }
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-action="toggle-mini-cart"][aria-controls="mini-cart"], a[aria-label="Carrinho"][aria-controls="mini-cart"]');
    if (toggle && !isCartPage()) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      if (miniCart() && miniCart().getAttribute('aria-hidden') === 'false') closeDrawer();
      else openDrawer();
      return;
    }

    var close = event.target.closest('#mini-cart [data-action="close"], #mini-cart .drawer__close-button, .drawer__overlay');
    if (close) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var checkoutButton = event.target.closest('[data-yampi-cart-checkout], .cart-recap__checkout');
    if (checkoutButton && window.ruvoUseYampiCheckout === false) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      window.location.href = '/checkout';
      return;
    }

    var qtyControl = event.target.closest('#mini-cart [data-action="increase-quantity"], #mini-cart [data-action="decrease-quantity"], #mini-cart .mini-cart__quantity-remove, [data-section-type="cart"] [data-action="increase-quantity"], [data-section-type="cart"] [data-action="decrease-quantity"], [data-section-type="cart"] .line-item__quantity-remove');
    if (qtyControl) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      changeCart(qtyControl);
      return;
    }

    var shippingToggle = event.target.closest('.estimate-shipping__toggle[aria-controls="shipping-estimator"]');
    if (shippingToggle) {
      var panel = document.getElementById('shipping-estimator');
      if (panel && (!panel.style.height || panel.style.height === '0px')) {
        window.setTimeout(function () {
          if (shippingToggle.getAttribute('aria-expanded') !== 'true') toggleCollapsible(shippingToggle, panel);
        }, 20);
      }
    }
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target.closest('#mini-cart .quantity-selector__value, [data-section-type="cart"] .quantity-selector__value');
    if (!input) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    changeCart(input);
  }, true);

  document.addEventListener('skin:cart:added', scheduleOpenAfterAdd, true);
  document.addEventListener('product:added', scheduleOpenAfterAdd, true);
  document.documentElement.addEventListener('cart:refresh', function (event) {
    var drawer = miniCart();
    var isOpen = drawer && drawer.getAttribute('aria-hidden') === 'false';
    var forced = event && event.detail && event.detail.ruvoForce === true;
    if (isOpen || forced) refreshMiniCart(isOpen || forced);
  }, true);

  function initRuvoCart() {
    closeDrawer();
    bootShippingEstimator();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRuvoCart);
  } else {
    initRuvoCart();
  }
})();

